import Vue from 'vue'
import Router from 'vue-router'

import HelloWorld from './pages/HelloWorld'
import messages from './locales'
import Homepage from './pages/Homepage'
// import Theme from './pages/Theme'
import Project from './pages/Project'
import Projects from './pages/Projects'
import EndPage from './pages/EndPage'
import SimplePage from './pages/SimplePage'
import Promise from './pages/Promise'

Vue.use(Router)

const routes = [
  {
    path: '',
    name: 'Homepage',
    component: Homepage,
    meta: {
      isFull: true,
      raycast: true,
      isWebGL: true
    }
  },
  {
    path: 'promise/:slug',
    name: 'Promise',
    component: Promise,
    meta: {
      isFull: true,
      raycast: true,
      isWebGL: true
    }
  },
  {
    path: 'projects/:slug',
    name: 'Project',
    component: Project,
    meta: {
      isFull: false,
      raycast: false,
      isWebGL: false
    }
  },
  {
    path: 'projects',
    name: 'Projects',
    component: Projects,
    meta: {
      isFull: false,
      raycast: false,
      isWebGL: false
    }
  },
  {
    path: 'end-page',
    name: 'EndPage',
    component: EndPage,
    meta: {
      isFull: false,
      raycast: false,
      isWebGL: false
    }
  },
  {
    path: ':slug',
    name: 'SimplePage',
    component: SimplePage,
    meta: {
      isFull: false,
      raycast: false,
      isWebGL: false
    }
  },
  {
    path: '*',
    redirect: '/',
  }
]

let langRoutes = []

for (let i = 0; i < routes.length; i++)  {
  for (const locale of Object.keys(messages)) {
    const prefix = locale === 'en' ? '' : locale + '/'
    let route = {...routes[i]}
    route.path = '/' + prefix + route.path
    route.name = prefix + route.name
    route.meta = {
      ...routes[i].meta,
      locale: locale
    }

    langRoutes.push(route)
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes: langRoutes
})
